export const TABLE_COLUMN_KEYS = {
  INVOICE: 'invoice',
  CLIENT: 'client',
  DUEDATE: 'dueDate',
  AMOUNT: 'amount',
  STATUS: 'status',
  ACTION: 'action',
};
